import client from '../client/bugsnag'

export default function logError (error: Error): void {
  if (__DEV__) {
    console.error(error)
  } else {
    client.notify(error)
  }
}
